import { SxProps } from '@mui/material'

import { calc } from '@/utils'

import { navigationDrawerClasses, navigationDrawerDimensions } from '..'

interface NavigationListStyles {
  container: SxProps
  navigationItem: SxProps
  itemName: SxProps
}

export const navigationListStyles: NavigationListStyles = {
  container: {
    width: '100%',
    height: calc(navigationDrawerDimensions.footer + navigationDrawerDimensions.header),
    overflow: 'auto',
  },

  navigationItem: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 2,
    cursor: 'pointer',
    overflow: 'hidden',
    justifyContent: 'space-between',
    py: 1.5,
    px: 2,

    [`.${navigationDrawerClasses.chevronIcon}`]: {
      width: 20,
      color: 'text.placeHolder',
    },
  },

  itemName: {
    typography: 'textMdSemibold',
    textTransform: 'capitalize',
    color: 'text.primary900',
  },
}
